import './SingleTextLoader.scss';

export default function SingleTextLoader() {
  return (
    <div className="loader single-text-loader">
      <div className="description" />
    </div>
  );
}
